import Image from './image';
import isTga from './isformat';

export default {
  Image,
  isTga,
};
